import { useQuery } from "@tanstack/react-query";
import { ISystemMessagesApi } from "@/api/system-messages";
import { SERVICES_TYPES, useInjection } from "@/ioc";

export const useSystemMessages = () => {
  const systemMessagesApi = useInjection<ISystemMessagesApi>(SERVICES_TYPES.SYSTEM_MESSAGES);

  return useQuery({
    queryKey: ["system-messages"],
    queryFn: () => systemMessagesApi.getAll()
  });
};
